/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Proposals API
 * Moment's Proposals API allows Clients to manage optimization proposals.
 * OpenAPI spec version: 1.0.0
 */

/**
 * The unit in which the optimizer decided an order's size: share count (equity, ETF), par dollars (fixed income), or notional dollars (mutual funds). Mirrors the trading-system order size types.
 */
export type OrderSizeType = typeof OrderSizeType[keyof typeof OrderSizeType];


export const OrderSizeType = {
  OrderSizeTypeShares: 'shares',
  OrderSizeTypePar: 'par',
  OrderSizeTypeNotional: 'notional',
} as const;
